import React, { useEffect, useState } from "react";
import { UsersInnerOptions } from "../UsersInnerOptions";
import { useQuery } from "react-query";
import { useErrorHandler } from "Exceptions/ErrorHandler";
import { SettingLayout } from "layouts/SettingLayout";
import { useColumns } from "./columns";
import { DataTable } from "components/ui/DataTable";
import { Planner } from "contracts/Planners";
import { getPlanners } from "hooks/api/Users/getPlanners";

const ListPlanners = () => {
  const { options } = UsersInnerOptions();
  const [localData, setLocalData] = useState<Planner[]>([]);
  const { errorHandler } = useErrorHandler();
  const { columns } = useColumns();
  const { data, isLoading } = useQuery({
    queryKey: "planners",
    queryFn: getPlanners,
    onError: errorHandler,
  });

  useEffect(() => {
    if (data) {
      setLocalData(data);
    }
    return () => {
      setLocalData([]);
    };
  }, [data]);
  return (
    <SettingLayout options={options}>
      <DataTable
        isLoading={isLoading}
        data={localData ?? []}
        filterBy={'Nome'}
        columns={columns}
        showControlColumns={false}
      />
    </SettingLayout>
  );
};

export default ListPlanners;
